import React from 'react';

import { Grid, Fade } from '@material-ui/core';

import { bool, array, object } from 'prop-types';
import { generate } from 'shortid';
import { withTheme } from 'styled-components';

import { createProductLink, getColorHeader } from '../../../../../../../libs';
import InfoMessage from '../../../../../../InfoMessage';
import LoadingSpinner from '../../../../../../LoadingSpinner';

import HeaderProductCard from './HeaderProductCard';
import { SearchContainer, SearchTitle, ListSuggestions, ListItemSuggestions, Link } from './styles';

const HeaderSearchBox = ({ open, suggestions, products, isLoading, error, theme }) => (
  <Fade in={open && (products.length > 0 || suggestions.length > 0)} exit unmountOnExit timeout={500}>
    <SearchContainer container>
      <Grid container>
        {!suggestions.length && !products.length && (
          <LoadingSpinner isLoading={isLoading} color={getColorHeader({ theme })} />
        )}
        {!isLoading && (error.status || error.message) && (
          <Grid container>
            <InfoMessage message={error.message} />
          </Grid>
        )}
        {suggestions.length > 0 && (
          <Grid item md={3} sm={12} xs={12}>
            <SearchTitle>Sugestões</SearchTitle>
            <ListSuggestions>
              {suggestions.map((sugg) => (
                <ListItemSuggestions key={`term-${generate()}`}>
                  <Link title={sugg.term} aria-label={sugg.term} href={`/busca?content=${sugg.term}`}>
                    {sugg.term}
                  </Link>
                </ListItemSuggestions>
              ))}
            </ListSuggestions>
          </Grid>
        )}
        {products.length > 0 && (
          <Grid item md={9} sm={12} xs={12}>
            <SearchTitle>Produtos encontrados:</SearchTitle>
            <Grid container>
              {products.map((item) => (
                <HeaderProductCard
                  key={`card-${generate()}`}
                  product={item}
                  href={createProductLink(item.name, item.id)}
                />
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>
    </SearchContainer>
  </Fade>
);

HeaderSearchBox.defaultProps = {
  suggestions: [],
  products: [],
  error: {},
};

HeaderSearchBox.propTypes = {
  open: bool,
  suggestions: array,
  products: array,
  isLoading: bool,
  error: object,
  theme: object,
};

export default withTheme(HeaderSearchBox);
